import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/28_mountain_lake/28_mountain_lake"
 * Contains 1 texture(s)
 */
export class Mobile28MountainLakeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/28_mountain_lake/28_mountain_lake';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '28_mountain_lake.jpg'
    ] as const;
}
